// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RM8i","content":"styles_content__1ZQOi","row":"styles_row__n1V_U","footer":"styles_footer__ZjUZe","phraseLength":"styles_phraseLength__4DAvm"};